export const PASSWORD_RESET_REQUEST = "PASSWORD_RESET_REQUEST";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_ERROR = "PASSWORD_RESET_ERROR";

export const passwordResetRequest = (payload) => ({
  type: PASSWORD_RESET_REQUEST,
  ...payload,
});

export const passwordResetSuccess = () => ({
  type: PASSWORD_RESET_SUCCESS,
});

export const passwordResetError = (error) => ({
  type: PASSWORD_RESET_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/password-reset/actions.js